import {
  Dashboard,
  FormatShapes,
  LocationOn,
  Description,
  StarsRounded,
  Pets,
  RememberMe,
  TipsAndUpdates,
  Quiz,
  CardGiftcard,
  Sick,
  EmojiEvents,
  ReceiptLong,
  AccountCircleRounded,
  School,
  PeopleOutlined,
  ManageAccounts,
  ContactSupport,
  Handshake,
  Assessment,
} from "@mui/icons-material";
import { lazy } from "react";
import RouteName from "./Route.name";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import SettingsIcon from "@mui/icons-material/Settings";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Constants from "../config/constants";


const HcpDoctorDashboard = lazy(() => import("../views/HcpDoctorDashboard/HcpDoctorDashboard.view"));
const StyleGuide = lazy(() => import("../views/StyleGuide/StyleGuide"));
const ClientList = lazy(() => import("../views/ClientManagement/ClientList.container"));
const ClientCreate = lazy(() => import("../views/ClientManagement/Create/ClientCreate"));
const AreaManagerDetail = lazy(() => import("../views/AreaManagerDetail/AreaManagerDetail.view"));

const StateCreate = lazy(() => import("../views/StateCity/Create/StateCreate.view"));
const StateList = lazy(() => import("../views/StateCity/StateList"));
const CityList = lazy(() => import("../views/StateCity/CityList"));
const ProgramList = lazy(() => import("../views/ProgramManagement/ProgramList"));
const ProgramCreate = lazy(() => import("../views/ProgramManagement/Create/ProgramCreate.view"));
const ClientDetail = lazy(() => import("../views/ClientManagement/Detail/ClientDetail"));
const PopularCitiesList = lazy(() => import("../views/PopularCities/PopularCitiesList"));
const ProgramDetail = lazy(() => import("../views/ProgramManagement/Detail/ProgramDetail"));
const PetList = lazy(() => import("../views/PetMaster/PetList"));
const PetCreate = lazy(() => import("../views/PetMaster/Create/PetCreate.view"));
const AppUsersList = lazy(() => import("../views/AppUsers/AppUsersList"));
const AppUsersDetail = lazy(() => import("../views/AppUsers/Detail/AppUsersDeatil"));
const QuizCreate = lazy(() => import("../views/Quiz/Create/QuizCreate.view"));
const QuizDetail = lazy(() => import("../views/Quiz/Detail/QuizDetail.view"));
const QuizList = lazy(() => import("../views/Quiz/List/QuizList"));
const HealthTips = lazy(() => import("../views/HealthTipsMaster/Create/HealthTips.view"));
const HealthTipsList = lazy(() => import("../views/HealthTipsMaster/HealthTipsList"));
const HealthTipsDetail = lazy(() => import("../views/HealthTipsMaster/Detail/HealthTipsDetail.view"));
const AppSettingsContainer = lazy(() => import("../views/AppSettings/AppSettings.container"));
const AppSettings = lazy(() => import("../views/AppSetting/AppSetting.view"));
const DoctorsList = lazy(() => import("../views/DoctorMaster/DoctorList.container"));
const RewardList = lazy(() => import("../views/Reward/List/RewardList"));
const RewardCreate = lazy(() => import("../views/Reward/Create/RewardCreate.view"));
const DashboardPage = lazy(() => import("../views/dashboard/Dashboard"));
const GiftStoreList = lazy(() => import("../views/GiftsStore/List/GiftStoreList"));
const GiftStoreCreate = lazy(() => import("../views/GiftsStore/Create/GiftStoreCreate.view"));
const GiftsStoreDetail = lazy(() => import("../views/GiftsStore/Detail/GiftsStoreDetail.view"));
const ReportedSideEffects = lazy(() => import("../views/ReportedSideEffects/Detail/ReportedSideEffects.view"));
const ReportedSideEffectsList = lazy(() => import("../views/ReportedSideEffects/List/ReportedSideEffectsList"));
const AuditTrialLog = lazy(() => import("../views/AuditTrialLog/AuditTrialLog.view"));
const AdminUsersDetail = lazy(() => import("../views/AdminUsers/Detail/AdminUsersdetail.view"));
const RoleDetail = lazy(() => import("../views/Roles/Detail/RoleDetail"));
const RoleCreate = lazy(() => import("../views/Roles/RoleCreate"));
const RolesList = lazy(() => import("../views/Roles/List/RolesList"));
const AdminUsersList = lazy(() => import("../views/AdminUsers/List/AdminUsersList.view"));
const AdminUsersCreate = lazy(() => import("../views/AdminUsers/Create/AdminUsersCreate.view"));
const UserQueriesList = lazy(() => import("../views/UserQueries/List/UserQueriesList.view"));
const UserQueriesDetail = lazy(() => import("../views/UserQueries/Detail/UserQueriesDetail.view"));
const UserDashboard = lazy(() => import("../views/UserDashboard/UserDashboard.view"));
const ProgramDashboard = lazy(() => import("../views/ProgramDashboard/ProgramDashboard.view"));
const DoctorDashboard = lazy(() => import("../views/DoctorDashboard/DoctorDashboard.view"));
const DietList = lazy(() => import("../views/Diet/List/DietList"));
const DietCreate = lazy(() => import("../views/Diet/Create/DietCreate.view"));
const DietDeatil = lazy(() => import("../views/Diet/Detail/DietDeatil"));
const ShiftsLists = lazy(() => import("../views/Shifts/Lists/ShiftsLists"));
const ShiftDetail = lazy(() => import("../views/Shifts/ShiftDetail/ShiftDetail"));
const Welcome = lazy(() => import("../views/Welcome/Welcome.view"));
const ManagerDashboard = lazy(() => import("../views/ManagerDashboard/ManagerDashboard.view"));
const SalesDetail = lazy(() => import("../views/SalesDetail/SalesDetail.view"));



const DietitianDashboard = lazy(
  () => import("../views/DietitionDashboard/DietitionDashboard.view")
);

const DietitianPatientDetail = lazy(
  () => import("../views/DietitionDashboard/components/PatientDetail/DietitianPatientDetail.view")
);
const dashboardRoutes = [
  // {
  //   path: "/",
  //   sidebarName: "Dashboard",
  //   icon: Dashboard,
  //   component: DashboardPage,
  //   is_sidebar: true,
  // },
  // {
  //   path: `${RouteName.STYLE_GUIDE}`,
  //   sidebarName: "Style Guide",
  //   icon: FormatShapes,
  //   component: StyleGuide,
  //   is_sidebar: true,
  // },
  {
    path: RouteName.PROGRAM,
    sidebarName: "Program Management",
    icon: Description,
    component: ProgramList,
    is_sidebar: true,
    module: Constants.MODULES.PROGRAM_MANAGEMENT,
    permissions: ["read"],
  },
  // {
  //   path: RouteName.PROGRAM_CREATE,
  //   sidebarName: "Program Management",
  //   parentRoute: `${RouteName.PROGRAM}`,
  //   icon: Description,
  //   component: ProgramCreate,
  //   is_sidebar: false,
  //   module: Constants.MODULES.PROGRAM_MANAGEMENT,
  //   permissions: ['read', 'create', 'update']
  // },
  // {
  //   path: `${RouteName.PROGRAM_UPDATE}:id`,
  //   sidebarName: "Program Management",
  //   parentRoute: `${RouteName.PROGRAM}`,
  //   icon: Description,
  //   component: ProgramCreate,
  //   is_sidebar: false,
  // },
  {
    path: `${RouteName.PROGRAM_DETAIL}:id`,
    sidebarName: "Program Management",
    parentRoute: `${RouteName.PROGRAM}`,
    icon: Description,
    component: ProgramDetail,
    is_sidebar: false,
    module: Constants.MODULES.PROGRAM_MANAGEMENT,
    permissions: ["read"],
  },
  {
    path: RouteName.APP_USERS,
    sidebarName: "App Users",
    icon: RememberMe,
    component: AppUsersList,
    is_sidebar: true,
    module: Constants.MODULES.APP_USERS,
    permissions: ["read"],
  },
  {
    path: `${RouteName.APP_DETAIL}:id`,
    sidebarName: "App Users",
    parentRoute: `${RouteName.APP_USERS}`,
    icon: RememberMe,
    component: AppUsersDetail,
    is_sidebar: false,
    module: Constants.MODULES.APP_USERS,
    permissions: ["read"],
  },

  {
    path: `${RouteName.DIETITIAN_PATIENT_DETAIL}:id`,
    sidebarName: "Dietitians Dashboard",
    icon: Dashboard,
    component: DietitianPatientDetail,
    is_sidebar: false,
    permissions: ["read"],
    parent: "admin_dashboards",
  },
  // {
  //   path: `${RouteName.CLIENT_MANAGEMENT}`,
  //   sidebarName: "Client Management",
  //   icon: GroupAddIcon,
  //   component: ClientList,
  //   is_sidebar: true,
  // },
  // {
  //   path: `${RouteName.CLIENT_CREATE}`,
  //   parentRoute: `${RouteName.CLIENT_MANAGEMENT}`,
  //   component: ClientCreate,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: `${RouteName.CLIENT_UPDATE}:id`,
  //   parentRoute: `${RouteName.CLIENT_MANAGEMENT}`,
  //   component: ClientCreate,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: `${RouteName.CLIENT_DETAIL}:id`,
  //   parentRoute: `${RouteName.CLIENT_MANAGEMENT}`,
  //   component: ClientDetail,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: RouteName.STATE_CITY,
  //   sidebarName: "State/City Master",
  //   icon: LocationOn,
  //   component: StateList,
  //   is_sidebar: true,
  // },
  // {
  //   path: `${RouteName.CITY}:id`,
  //   sidebarName: "State/City Master",
  //   parentRoute: `${RouteName.STATE_CITY}`,
  //   icon: LocationOn,
  //   component: CityList,
  //   is_sidebar: false,
  // },
  // {
  //   path: RouteName.POPULAR_CITIES,
  //   sidebarName: "Popular Cities",
  //   icon: StarsRounded,
  //   component: PopularCitiesList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.PET_MASTER,
  //   sidebarName: "Pet Master",
  //   icon: Pets,
  //   component: PetList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.PET_CREATE,
  //   sidebarName: "Pet Master",
  //   parentRoute: `${RouteName.PET_MASTER}`,
  //   icon: Pets,
  //   component: PetCreate,
  //   is_sidebar: false,

  // },
  // {
  //   path: `${RouteName.PET_UPDATE}:id`,
  //   sidebarName: "Pet Master",
  //   parentRoute: `${RouteName.PET_MASTER}`,
  //   icon: Pets,
  //   component: PetCreate,
  //   is_sidebar: false,
  // },
  {
    path: RouteName.ADMIN,
    sidebarName: "Client Users",
    icon: ManageAccounts,
    component: AdminUsersList,
    is_sidebar: true,
    // parent: "admin_users",
    module: Constants.MODULES.ADMIN_USERS,
    permissions: ["read"],
  },
  {
    path: RouteName.ADMIN_CREATE,
    sidebarName: "Admin Users",
    parentRoute: `${RouteName.ADMIN}`,
    icon: ManageAccounts,
    component: AdminUsersCreate,
    is_sidebar: false,
    parent: "admin_users",
    module: Constants.MODULES.ADMIN_USERS,
    permissions: ["create"],
  },
  {
    path: `${RouteName.ADMIN_UPDATE}:id`,
    sidebarName: "Admin Users",
    parentRoute: `${RouteName.ADMIN}`,
    icon: ManageAccounts,
    component: AdminUsersCreate,
    is_sidebar: false,
    parent: "admin_users",
    module: Constants.MODULES.ADMIN_USERS,
    permissions: ["update"],
  },
  {
    path: `${RouteName.ADMIN_DETAIL}:id`,
    sidebarName: "Admin Users",
    parentRoute: `${RouteName.ADMIN}`,
    icon: ManageAccounts,
    component: AdminUsersDetail,
    is_sidebar: false,
    parent: "admin_users",
    module: Constants.MODULES.ADMIN_USERS,
    permissions: ["read"],
  },
  {
    path: RouteName.HEALTH_TIPS,
    sidebarName: "Health Tips Master",
    icon: TipsAndUpdates,
    component: HealthTipsList,
    is_sidebar: true,
    module: Constants.MODULES.HEALTH_TIPS_MASTER,
    permissions: ["read"],
  },
  {
    path: RouteName.HEALTH_CREATE,
    sidebarName: "Health Tips Master",
    parentRoute: `${RouteName.HEALTH_TIPS}`,
    icon: TipsAndUpdates,
    component: HealthTips,
    is_sidebar: false,
    module: Constants.MODULES.HEALTH_TIPS_MASTER,
    permissions: ["create"],
  },
  {
    path: `${RouteName.HEALTH_UPDATE}:id`,
    sidebarName: "Health Tips Master",
    parentRoute: `${RouteName.HEALTH_TIPS}`,
    icon: TipsAndUpdates,
    component: HealthTips,
    is_sidebar: false,
    module: Constants.MODULES.HEALTH_TIPS_MASTER,
    permissions: ["update"],
  },
  {
    path: `${RouteName.HEALTH_DETAIL}:id`,
    sidebarName: "Health Tips Master",
    parentRoute: `${RouteName.HEALTH_TIPS}`,
    icon: TipsAndUpdates,
    component: HealthTipsDetail,
    is_sidebar: false,
    module: Constants.MODULES.HEALTH_TIPS_MASTER,
    permissions: ["read"],
  },
  {
    path: RouteName.QUIZ,
    sidebarName: "Quiz",
    icon: Quiz,
    component: QuizList,
    is_sidebar: true,
    module: Constants.MODULES.QUIZES_MODULE,
    permissions: ["read"],
  },
  // {
  //   path: RouteName.DIET,
  //   sidebarName: "Dietitian List",
  //   icon: Quiz,
  //   component: DietList,
  //   is_sidebar: true,
  //   module: Constants.MODULES.QUIZES_MODULE,
  //   permissions: ["read"],
  // },
  // {
  //   path: RouteName.DIET_CREATE,
  //   sidebarName: "Quiz",
  //   icon: Quiz,
  //   component: DietCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.DIET}`,
  //   module: Constants.MODULES.QUIZES_MODULE,
  //   permissions: ["create"],
  // },
  // {
  //   path: `${RouteName.DIET_DETAIL}:id`,
  //   sidebarName: "Quiz",
  //   icon: Quiz,
  //   component: DietDeatil,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.QUIZ}`,
  //   module: Constants.MODULES.QUIZES_MODULE,
  //   permissions: ["update"],
  // },
  // {
  //   path: RouteName.SHIFTS,
  //   sidebarName: "Shifts",
  //   navbarName: "Shifts",
  //   icon: PeopleOutlined,
  //   component: ShiftsLists,
  //   is_sidebar: true,
  //   is_protect: true,
  //   should_regex: true,
  //   // parent: "staff_manage",
  //   parentRoute: `${RouteName.QUIZ}`,
  //   module: Constants.MODULES.QUIZES_MODULE,
  //   permissions: ["update"],
  //   // roles: [Roles.ADMIN, Roles.CORPORATE_HR],
  // },
  // {
  //   path: `${RouteName.SHIFTS_DETAILS}:id`,
  //   navbarName: "Shifts",
  //   component: ShiftDetail,
  //   is_protect: true,
  //   should_regex: true,
  //   parent: "staff_manage",
  //   is_sidebar: false,
  //   // roles: [Roles.ADMIN, Roles.CORPORATE_HR],
  // },
  {
    path: RouteName.QUIZ_CREATE,
    sidebarName: "Quiz",
    icon: Quiz,
    component: QuizCreate,
    is_sidebar: false,
    parentRoute: `${RouteName.QUIZ}`,
    module: Constants.MODULES.QUIZES_MODULE,
    permissions: ["create"],
  },
  {
    path: `${RouteName.QUIZ_UPDATE}:id`,
    sidebarName: "Quiz",
    icon: Quiz,
    component: QuizCreate,
    is_sidebar: false,
    parentRoute: `${RouteName.QUIZ}`,
    module: Constants.MODULES.QUIZES_MODULE,
    permissions: ["update"],
  },
  {
    path: `${RouteName.QUIZ_DETAIL}:id`,
    sidebarName: "Quiz",
    icon: Quiz,
    component: QuizDetail,
    is_sidebar: false,
    parentRoute: `${RouteName.QUIZ}`,
    module: Constants.MODULES.QUIZES_MODULE,
    permissions: ["read"],
  },
  // {
  //   path: RouteName.REWARD,
  //   sidebarName: "Rewards Master",
  //   icon: EmojiEvents,
  //   component: RewardList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.REWARD_CREATE,
  //   sidebarName: "Quiz",
  //   icon: EmojiEvents,
  //   component: RewardCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.REWARD}`,
  // },
  // {
  //   path: `${RouteName.REWARD_UPDATE}:id`,
  //   sidebarName: "Quiz",
  //   icon: EmojiEvents,
  //   component: RewardCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.REWARD}`,
  // },
  // {
  //   path: RouteName.APP_SETTINGS,
  //   sidebarName: "App Settings",
  //   icon: SettingsIcon,
  //   component: AppSettings,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.DOCTOR_MASTER,
  //   sidebarName: "Doctor Master",
  //   icon: AddCircleIcon,
  //   component: DoctorsList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.GIFT,
  //   sidebarName: "Gifts Store",
  //   icon: CardGiftcard,
  //   component: GiftStoreList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.GIFT_CREATE,
  //   sidebarName: "Gifts Store",
  //   icon: CardGiftcard,
  //   component: GiftStoreCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.GIFT}`,
  // },
  // {
  //   path: `${RouteName.GIFT_UPDATE}:id`,
  //   sidebarName: "Gifts Store",
  //   icon: CardGiftcard,
  //   component: GiftStoreCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.GIFT}`,
  // },
  // {
  //   path: `${RouteName.GIFT_DETAIL}:id`,
  //   sidebarName: "Gifts Store",
  //   icon: CardGiftcard,
  //   component: GiftsStoreDetail,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.GIFT}`,
  // },
  {
    path: RouteName.DASHBOARD,
    sidebarName: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    is_sidebar: true,
    module: Constants.MODULES.DASHBOARD,
    permissions: ["read"],
  },
  // {
  //   path: RouteName.AUDIT_CREATE,
  //   sidebarName: "Audit Trail Log",
  //   icon: ReceiptLong,
  //   component: AuditTrialLog,
  //   is_sidebar: true,
  //   parentRoute: `${RouteName.AUDIT_CREATE}`,
  // },
  {
    path: RouteName.REPORTED,
    sidebarName: "Reported Side Effects",
    icon: Sick,
    component: ReportedSideEffectsList,
    is_sidebar: true,
    module: Constants.MODULES.REPORTED_SIDE_EFFECTS,
    permissions: ["read"],
  },
  {
    path: `${RouteName.REPORTED_DETAIL}:id`,
    sidebarName: "Reported Side Effects",
    icon: Sick,
    component: ReportedSideEffects,
    is_sidebar: false,
    parentRoute: `${RouteName.REPORTED}`,
    // module: Constants.MODULES.REPORTED_SIDE_EFFECTS,
    permissions: ["read"],
  },
  {
    path: RouteName.USER_QUERIES,
    sidebarName: "User Queries",
    icon: ContactSupport,
    component: UserQueriesList,
    is_sidebar: true,
    module: Constants.MODULES.USER_QUERIES,
    permissions: ['read']
  },
  {
    path: `${RouteName.USER_QUERIES_DETAIL}:id`,
    sidebarName: "User Queries",
    icon: ContactSupport,
    component: UserQueriesDetail,
    is_sidebar: false,
    parentRoute: `${RouteName.USER_QUERIES}`,
  },
  {
    path: "null",
    sidebarName: "Analytics Dashboard",
    navbarName: "Analytics Dashboard",
    icon: Assessment,
    is_sidebar: true,
    slug: "admin_dashboards",
    is_parent: true,
  },
  {
    path: RouteName.USER_ENGAGEMENT_DASHBOARD,
    sidebarName: "User Engagement",
    icon: Handshake,
    component: UserDashboard,
    is_sidebar: true,
    module: Constants.MODULES.USER_ENGAGEMENT,
    permissions: ['read'],
    parent: "admin_dashboards",
  },
  {
    path: RouteName.PROGRAM_DASHBOARD,
    sidebarName: "Program Adherence",
    icon: Dashboard,
    component: ProgramDashboard,
    is_sidebar: true,
    module: Constants.MODULES.PROGRAM_ADHERENCE,
    permissions: ["read"],
    parent: "admin_dashboards",
  },
  {
    path: RouteName.DOCTOR_DASHBOARD,
    sidebarName: "Doctor Performance",
    icon: Dashboard,
    component: DoctorDashboard,
    is_sidebar: true,
    module: Constants.MODULES.DOCTOR_PERFORMANCE,
    permissions: ["read"],
    parent: "admin_dashboards",
  },
  {
    path: RouteName.HCP_DOCTOR_DASHBOARD,
    sidebarName: "HCP Dashboard",
    icon: Dashboard,
    component: HcpDoctorDashboard,
    is_sidebar: false,
    module: Constants.MODULES.DOCTOR_PERFORMANCE,
    permissions: ["read"],
    // parent: "admin_dashboards",
    parent: "admin_dashboards",
  },
  {
    path: RouteName.MANAGER_DASHBOARD,
    sidebarName: "Managers Dashboard",
    icon: Dashboard,
    component: ManagerDashboard,
    is_sidebar: true,
    // module: Constants.MODULES.MANAGER_DASHBOARD,
    module: Constants.MODULES.DOCTOR_PERFORMANCE,
    permissions: ["read"],
    parent: "admin_dashboards",
  },

  {
    path: RouteName.DIETITIANS_DASHBOARD,
    sidebarName: "Dietitians Dashboard",
    icon: Dashboard,
    component: DietitianDashboard,
    is_sidebar: true,
    module: Constants.MODULES.DIETITIAN_DASHBOARD,
    permissions: ["read"],
    parent: "admin_dashboards",
  },
  {
    path: `${RouteName.SALES_INFO}:id`,
    sidebarName: "Managers Dashboard",
    icon: Dashboard,
    component: SalesDetail,
    is_sidebar: false,
    // module: Constants.MODULES.MANAGER_DASHBOARD,
    module: Constants.MODULES.DOCTOR_PERFORMANCE,
    permissions: ["read"],
    parent: "admin_dashboards",
  },
  {
    path: `${RouteName.AREA_MANAGER_INFO}:id`,
    sidebarName: "Managers Dashboard",
    icon: Dashboard,
    component: AreaManagerDetail,
    is_sidebar: false,
    module: Constants.MODULES.DOCTOR_PERFORMANCE,
    permissions: ["read"],
    parent: "admin_dashboards",
  },
  // {
  //   path: "null",
  //   sidebarName: "Admin Users",
  //   navbarName: "Admin Users",
  //   icon: AccountCircleRounded,
  //   is_sidebar: true,
  //   slug: "admin_users",
  //   is_parent: true,
  // },
  // {
  //   path: `${RouteName.ROLES}`,
  //   sidebarName: "Roles",
  //   icon: School,
  //   component: RolesList,
  //   is_sidebar: true,
  //   parent: "admin_users",
  // },
  // {
  //   path: `${RouteName.ROLE_CREATE}`,
  //   parentRoute: `${RouteName.ROLES}`,
  //   component: RoleCreate,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: `${RouteName.ROLE_UPDATE}:id`,
  //   parentRoute: `${RouteName.ROLES}`,
  //   component: RoleCreate,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: `${RouteName.ROLE_DETAIL}:id`,
  //   parentRoute: `${RouteName.ROLES}`,
  //   component: RoleDetail,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  {
    path: `${RouteName.WELCOME}`,
    sidebarName: "Welcome",
    icon: ContactSupport,
    component: Welcome,
    is_sidebar: false,
    // module: Constants.MODULES.WELCOME,

  },
];

export default dashboardRoutes;
